var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"basket_link",attrs:{"href":"/basket"}},[_c('span',[_vm._v("Basket")]),_c('i',{staticClass:"fal fa-fw fa-shopping-basket",class:{ hasitems: this.working_count > 0 },attrs:{"data-count":this.working_count}})])
}
var staticRenderFns = []

export { render, staticRenderFns }